export default function getFormattedTableCell(cellData) {
  if (typeof cellData === 'boolean') {
    if (cellData === true) return 'Yes';
    else return 'No';
  }
  return cellData;
}
